export default "/images/db66ccca393181e6ed6da6d79968c388.avif";